export enum EUDRBenchmarking {
  LOW = "low",
  STANDARD = "standard",
  HIGH = "high",
}

export const EUDR_DISPLAY_TEXT = {
  [EUDRBenchmarking.LOW]: "Low risk",
  [EUDRBenchmarking.STANDARD]: "Standard risk",
  [EUDRBenchmarking.HIGH]: "High risk",
} as const;
